import { proxyCustomElement, HTMLElement, h, createEvent } from '@stencil/core/internal/client';
import { r as remCalc } from './index5.js';
import { D as DomService, T as TrackingService } from './index3.js';
import './index2.js';
import { R as RocheModalTrigger } from './roche-modal-trigger.js';
import { A as AdobeTracking } from './index7.js';
import { d as defineCustomElement$1 } from './roche-icon2.js';

var Target;
(function (Target) {
    Target["SELF"] = "_self";
    Target["BLANK"] = "_blank";
})(Target || (Target = {}));
const targetKeys = Object.keys(Target);
const targetValues = Object.values(Target);
var ButtonType;
(function (ButtonType) {
    ButtonType["BUTTON"] = "button";
    ButtonType["SUBMIT"] = "submit";
    ButtonType["RESET"] = "reset";
})(ButtonType || (ButtonType = {}));
const buttonTypeKeys = Object.keys(ButtonType);
const buttonTypeValues = Object.values(ButtonType);
var ButtonAlignment;
(function (ButtonAlignment) {
    ButtonAlignment["LEFT"] = "left";
    ButtonAlignment["CENTER"] = "center";
})(ButtonAlignment || (ButtonAlignment = {}));
var ButtonAppearance;
(function (ButtonAppearance) {
    ButtonAppearance["PRIMARY"] = "primary";
    ButtonAppearance["SECONDARY"] = "secondary";
    ButtonAppearance["TERTIARY"] = "tertiary";
    ButtonAppearance["SUCCESS"] = "success";
    ButtonAppearance["ERROR"] = "error";
    ButtonAppearance["BOTTOM_FIXED"] = "bottom-fixed";
})(ButtonAppearance || (ButtonAppearance = {}));
Object.values(ButtonAppearance);

const rocheButtonCss = ":host{display:block;margin-top:3rem;margin-top:2rem}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}:host button{display:block;padding:0;border:0;background-color:transparent;border-radius:0;text-align:center}:host a{text-decoration:none;text-align:center}@media (min-width: 48rem){:host{display:inline-block}}:host .text{pointer-events:none}:host .icon-container{display:flex;align-items:center;position:relative;width:1rem;height:1rem;pointer-events:none}:host .button{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-weight:400;font-size:var(--button--font-size--small-up);line-height:1.3125rem;position:relative;width:100%;height:3.5rem;display:flex;justify-content:center;align-items:center;padding:1rem 1.5rem;cursor:pointer;user-select:none;transition-property:background, box-shadow, color;transition-duration:0.22s;transition-timing-function:ease-in}@media (min-width: 48rem){:host .button{font-size:var(--button--font-size--medium-up);line-height:1.4375rem}}@media (min-width: 48rem){:host .button{min-width:6rem}}:host .button>*+*{margin-left:0.75rem}:host .button .icon{fill:currentcolor;pointer-events:none}:host .button--left-aligned{justify-content:start}:host .button--primary{background:var(--color-interactive--primary-idle);color:#fff}:host .button--primary:focus,:host .button--primary:focus-visible{outline:var(--color-interactive--focus) dashed 2px;outline-offset:unset}:host .button--primary:focus:not(:focus-visible){outline:none}:host .button--primary:focus{background-color:var(--color-interactive--primary-idle)}:host .button--primary:focus-visible{background-color:var(--color-interactive--primary-idle)}:host .button--primary:hover{background:var(--color-interactive--primary-hover);box-shadow:0 0.75rem 1.5rem rgba(33, 33, 33, 0.24)}:host .button--primary:active{background:var(--color-interactive--active)}:host .button--primary.button--disabled{border-color:transparent;background:var(--color-interactive--disabled);color:var(--color-text--secondary);cursor:default}:host .button--primary.button--disabled:hover{box-shadow:none}:host .button--secondary{background:transparent;border:1px solid var(--color-interactive--primary-idle);color:var(--color-interactive--primary-idle)}:host .button--secondary:focus,:host .button--secondary:focus-visible{outline:var(--color-interactive--focus) dashed 2px;outline-offset:unset}:host .button--secondary:focus:not(:focus-visible){outline:none}:host .button--secondary:focus,:host .button--secondary:focus-visible{border:1px solid transparent;color:var(--color-interactive--primary-idle)}:host .button--secondary:hover{border:1px solid var(--color-interactive--primary-hover);color:var(--color-interactive--primary-hover)}:host .button--secondary:active{border:1px solid var(--color-interactive--primary-idle);color:var(--color-interactive--primary-idle)}:host .button--secondary:focus:not(:focus-visible){border:1px solid var(--color-interactive--primary-idle);color:var(--color-interactive--primary-idle)}:host .button--secondary:focus:hover{border:1px solid var(--color-interactive--primary-hover);color:var(--color-interactive--primary-hover)}:host .button--secondary:focus:active{border:1px solid var(--color-interactive--primary-idle);color:var(--color-interactive--primary-idle)}:host .button--secondary.button--disabled{border-color:var(--color-text--secondary);background:transparent;color:var(--color-text--secondary);cursor:default}:host .button--secondary.button--disabled:hover{box-shadow:none}:host .button--tertiary{background:transparent;color:var(--color-interactive--primary-idle)}@media (min-width: 48rem){:host .button--tertiary{min-width:100%}}:host .button--tertiary:focus,:host .button--tertiary:focus-visible{outline:var(--color-interactive--focus) dashed 2px;outline-offset:unset}:host .button--tertiary:focus:not(:focus-visible){outline:none}:host .button--tertiary:hover{color:var(--color-interactive--primary-hover);background:var(--color-interactive--secondary-hover)}:host .button--tertiary:active{background:transparent}:host .button--tertiary.button--disabled{border-color:transparent;background:transparent;color:var(--color-text--secondary);cursor:default}:host .button--tertiary.button--disabled:hover{box-shadow:none}:host .button--success{background:var(--color-status--success);color:#fff;pointer-events:none;cursor:default}:host .button--error{background-color:var(--color-status--error);color:#fff;pointer-events:none;cursor:default}:host .button--bottom-fixed{background-color:#fff;border-radius:0.9375rem 0.9375rem 0 0;bottom:0;left:0;box-shadow:0 -0.1875rem 0.5rem rgba(0, 0, 0, 0.25);cursor:pointer;height:4rem;justify-content:center;position:fixed;z-index:50;color:#0b41cd}:host .button--bottom-fixed roche-icon{color:#000}:host .button .loading-spinner{animation:loading-spinner 2s linear infinite;fill:white}:host([no-margin]) a,:host([no-margin]) button{margin:0}@keyframes loading-spinner{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}:host([dir=rtl]) .button>*+*{margin:0 0.75rem 0 0}";
const RocheButtonStyle0 = rocheButtonCss;

const RocheButton = /*@__PURE__*/ proxyCustomElement(class RocheButton extends HTMLElement {
    get typeParsed() {
        const index = buttonTypeValues.indexOf(this.type);
        return index >= 0 ? Target[buttonTypeKeys[index]] : ButtonType.BUTTON;
    }
    get targetParsed() {
        const index = targetValues.indexOf(this.target);
        return index >= 0 ? Target[targetKeys[index]] : Target.SELF;
    }
    // eslint-disable-next-line class-methods-use-this
    get defaultTracking() {
        return {
            event: 'button_click',
            component_name: 'roche-button',
        };
    }
    static createIconElement(icon) {
        return (h("div", { class: 'icon-container' }, h("roche-icon", { class: "icon", icon: icon, height: `${remCalc(16)}rem` })));
    }
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.buttonClickEvent = createEvent(this, "rocheButtonClick", 7);
        this.text = undefined;
        this.isModalTrigger = false;
        this.isSearchTrigger = false;
        this.leftIcon = undefined;
        this.rightIcon = undefined;
        this.href = undefined;
        this.type = ButtonType.BUTTON;
        this.target = Target.SELF;
        this.disabled = false;
        this.noMargin = false;
        this.preventTracking = false;
        this.download = undefined;
        this.appearance = ButtonAppearance.PRIMARY;
        this.alignment = ButtonAlignment.CENTER;
        this.handleClick = this.handleClick.bind(this);
    }
    componentDidLoad() {
        DomService.handleTextDirection(this.element);
    }
    render() {
        const ButtonElement = this.href ? 'a' : 'button';
        const props = this.href ? Object.assign(Object.assign({ target: this.targetParsed }, (this.download ? { download: this.download } : {})), (!this.disabled ? { href: this.href } : {})) : {
            type: this.typeParsed,
            disabled: this.disabled,
            appearance: this.appearance,
        };
        const buttonClasses = {
            button: true,
            'button--disabled': this.disabled,
            'button--left-aligned': this.alignment === ButtonAlignment.LEFT,
            'button--primary': this.appearance === ButtonAppearance.PRIMARY,
            'button--secondary': this.appearance === ButtonAppearance.SECONDARY,
            'button--tertiary': this.appearance === ButtonAppearance.TERTIARY,
            'button--success': this.appearance === ButtonAppearance.SUCCESS,
            'button--error': this.appearance === ButtonAppearance.ERROR,
            'button--bottom-fixed': this.appearance === ButtonAppearance.BOTTOM_FIXED,
        };
        return (h(ButtonElement, Object.assign({ key: 'd262919bf0cc14d9ea7f61ce465d377591d7a4dd', class: buttonClasses }, props, { onClick: this.handleClick }), this.leftIcon && RocheButton.createIconElement(this.leftIcon), h("div", { key: '30b90fcfb51c8b4b70433d0190c29f4a4a9430fc', class: "text", "data-content": this.text }, this.text), this.rightIcon && RocheButton.createIconElement(this.rightIcon)));
    }
    handleClick(event) {
        var _a, _b;
        if (this.isModalTrigger && !this.isSearchTrigger) {
            event.preventDefault();
            RocheModalTrigger.trigger(this.element.id);
        }
        if (this.disabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        const target = event.target;
        if ((_b = (_a = target === null || target === void 0 ? void 0 : target.attributes) === null || _a === void 0 ? void 0 : _a.getNamedItem('href')) === null || _b === void 0 ? void 0 : _b.value) {
            this.trackClick({ event, isLink: true });
            return;
        }
        event.stopPropagation();
        this.trackClick({ event, isLink: false });
        this.buttonClickEvent.emit();
    }
    // eslint-disable-next-line class-methods-use-this
    get adobeTracking() {
        return {
            innerText: this.text,
            url: this.href,
            position: 'RocheButton',
            type: this.type || ButtonType.BUTTON,
            socialMedia: '',
            socialInteraction: '',
        };
    }
    trackClick({ event, isLink }) {
        const { defaultTracking } = this;
        const additionalParameters = {};
        if (this.preventTracking) {
            return;
        }
        if (isLink) {
            defaultTracking.event = 'link_click';
            additionalParameters.click_text = this.text;
            additionalParameters.click_url = this.href;
        }
        else {
            additionalParameters.button_label = this.text;
        }
        TrackingService.push(Object.assign(Object.assign({}, defaultTracking), { additionalParameters: Object.assign(Object.assign({}, additionalParameters), TrackingService.getParentAwareTrackingInfo(event)) }));
        AdobeTracking(this.adobeTracking, 'defaultLinkClick');
    }
    get element() { return this; }
    static get style() { return RocheButtonStyle0; }
}, [1, "roche-button", {
        "text": [1],
        "isModalTrigger": [4, "is-modal-trigger"],
        "isSearchTrigger": [4, "is-search-trigger"],
        "leftIcon": [1, "left-icon"],
        "rightIcon": [1, "right-icon"],
        "href": [1],
        "type": [1],
        "target": [1],
        "disabled": [4],
        "noMargin": [4, "no-margin"],
        "preventTracking": [4, "prevent-tracking"],
        "download": [1],
        "appearance": [1],
        "alignment": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-button", "roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-button":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheButton);
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { ButtonAlignment as B, RocheButton as R, Target as T, ButtonAppearance as a, ButtonType as b, defineCustomElement as d };

//# sourceMappingURL=roche-button2.js.map